import { z } from "zod"

export const commentReactionRecordSchema = z.object({
    comment_id: z.uuid(),
    org_id: z.uuid(),
    user_id: z.guid(),
    emoji: z.string(),
    created_at: z.string(),
})

export const commentReactionSchema = commentReactionRecordSchema.transform((r) => ({
    commentId: r.comment_id,
    orgId: r.org_id,
    userId: r.user_id,
    emoji: r.emoji,
    createdAt: r.created_at,
}))

export const commentReactionSummaryRecordSchema = z.object({
    emoji: z.string(),
    user_ids: z.array(z.guid()),
})

export const commentReactionSummarySchema = commentReactionSummaryRecordSchema.transform((r) => ({
    emoji: r.emoji,
    userIds: r.user_ids,
}))

export type CommentReactionRecord = z.infer<typeof commentReactionRecordSchema>
export type CommentReaction = z.infer<typeof commentReactionSchema>
export type CommentReactionSummary = z.infer<typeof commentReactionSummarySchema>
